import { createAction, props } from '@ngrx/store';

export const endWorkScanFlow = createAction('[ScanFlow] End Work', props<{ endWorkTimestamp: number }>());
